import { render, staticRenderFns } from "./ChatMiddleEmoji.vue?vue&type=template&id=ca2db8b4&"
import script from "./ChatMiddleEmoji.vue?vue&type=script&lang=js&"
export * from "./ChatMiddleEmoji.vue?vue&type=script&lang=js&"
import style0 from "./ChatMiddleEmoji.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports